/* src/app/modules/print-cards/components/cards/backgrounds/post-cards-4x6/jane-doe-post-card-stack-background/jane-doe-post-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
}
:host .outside-border {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host .outside-border .main-content {
  background-color: #ffffff;
}
/*# sourceMappingURL=jane-doe-post-card-stack-background.component.css.map */
